import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/Layout';
import JoinTeamSection from '../components/homepage/JoinTeamSection';
import ProductVideoSection from '../components/homepage/ProductVideoSection';
import PersonaCardGrid from '../components/shared/CardGrid';
import HomePageHero from '../components/homepage/HomePageHero';
import HomePageHeroImage from '../images/homepage-hero-image.png';
import V2HomePage from './v2/index';

const PERSONA_ROW_DATA = [
  [
    {
      title: 'Home Improvement Professionals',
      body: 'All exterior measurements: every facet, any home. Measure, design, and estimate with accuracy in 3D.',
      href: '/exterior-contractors/',
    },
    {
      title: 'Insurance Carriers & Carrier Partners',
      body: 'Most complete property data package for any property. Reduce cycle times and add transparency.',
      href: '/insurance/',
    },
    {
      title: 'Homeowners',
      body: 'See a new roof, siding, and windows on your home in 3D. Understand and trust your estimates.',
      href: '/homeowners/',
    },
  ],
  [
    {
      title: 'Architects & Designers',
      body: 'Save time and money during the Schematic Design stage with an exportable 3D model.',
      href: '/measurement-app-architects/',
    },
    {
      title: 'Tax Assessors',
      body: 'Auto-generate gross living area data at 2x the speed with more accuracy than aerial imagery or measuring tape.',
      href: '/tax-assessors/',
    },
  ],
];

const HomePage = () => (
  <Layout
    isNavInitiallyTransparent={false}
    title="Fully Measured, Customizable 3D Models"
  >
    <Helmet>
      <link rel="preload" as="image" href={HomePageHeroImage} />
    </Helmet>
    <HomePageHero />
    <PersonaCardGrid
      gridTitle="Unlock the potential of property."
      rows={PERSONA_ROW_DATA}
    />
    <ProductVideoSection />
    <JoinTeamSection />
  </Layout>
);

export default process.env.GATSBY_V2_PREFIX === '' ? V2HomePage : HomePage;
